import { gql } from "@urql/core";

// ============================================
// Patient User Query
// ============================================

export const GET_ALL_PATIENT_USERS_IN_ORG = gql`
  query getAllPatientUsers {
    getAllPatientUsers {
      user_id
      vitall_patient {
        patient_id
        vitall_patient_id
      }
    }
  }
`;

export const GET_VITALL_PATIENT_RECORD_QUERY = gql`
  query getVitallPatientRecord($input: GetVitallPatientRecordInput!) {
    getVitallPatientRecord(input: $input) {
      vitall_patient_id
      user_id
      patient_id
    }
  }
`;

// ============================================
// Patient User Mutations
// ============================================

export const ADMIN_CHANGE_NAME_MUTATION = gql`
  mutation adminChangeName($input: ChangeUserNameInput!) {
    adminChangeName(input: $input) {
      success
      message
      data {
        user_id
        first_name
        last_name
        middle_name
        email
      }
    }
  }
`;

// ===================================================
// TypeScript Types
// ===================================================

/**
 * Get patient users response
 */
export interface GetAllPatientUsersResponse {
  user_id: string;
  vitall_patient?: {
    patient_id: string;
    vitall_patient_id: string;
  };
}

/**
 * VitallPatient model from getVitallPatientRecord query
 */
export interface VitallPatientModel {
  vitall_patient_id: string;
  user_id: string;
  patient_id: string;
}

/**
 * Input for getVitallPatientRecord query.
 * All fields optional — provide at least one identifier to resolve the record.
 */
export interface GetVitallPatientRecordInput {
  patient_id?: string;
  user_id?: string;
  vitall_patient_id?: string;
}

/**
 * getVitallPatientRecord query response
 */
export interface GetVitallPatientRecordData {
  getVitallPatientRecord: VitallPatientModel;
}

/**
 * User model returned inside the adminChangeName mutation response.
 */
export interface UserModel {
  user_id: string;
  first_name: string;
  last_name: string;
  middle_name?: string;
  email: string;
}

/**
 * adminChangeName mutation response.
 * The user fields are nested under `data`; the wrapper carries `success`/`message`.
 */
export interface UpdateUserResponse {
  success: boolean;
  message?: string;
  data: UserModel;
}

/**
 * adminChangeName mutation response wrapper
 */
export interface AdminChangeNameData {
  adminChangeName: UpdateUserResponse;
}
